import instance from "../../utils/axios";

// ✅ Save Program Language Meta
export const saveProgramLanguageMeta = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val ?? "")
  );

  const response = await instance.post("/churches/languagemetas/programs/save", formData);
  return response.data;
};
